import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { RouteComponentProps } from 'react-router'
import { Card, Row, Col, Button } from 'antd'
import { FormComponent, BaseFormComponentProps } from '../../../BaseComponent'
import Filters, { FilterItem, Types } from '../../../Filters'
import ShelterProductList from '../../../ShelterProductList'
import { ShelterProductForm } from '../../../Forms'
import { ShelterProductConsumer } from '../../../../context/ShelterProductContext'
import { SearchRequest } from '../../../../services/api/interfaces/ApiRequest'

type ProductProps = BaseFormComponentProps & RouteComponentProps & {
  uuid: string,

  contentLoading: boolean,

  shelter: any | null,
  loadShelter: (args: SearchRequest) => void,

  species: any | null,
  loadSpecies: (args: SearchRequest) => void
}

class Product extends FormComponent<ProductProps> {

  state = {
    saving: false
  }

  private productDispatchOptions = {
    search: {
      shelter: {
        has: {
          uuid: this.props.uuid
        }
      },
      'product_branch': {
        with: {
          deleted: false,
          _exists: true,
          branch: {
            with: true
          }
        }
      },
      'product_specie': {
        with: {
          deleted: false,
          _exists: true,
          specie: {
            with: true
          }
        }
      }
    },
    options: {
      _force_ids: true
    }
  } as const

  componentDidMount() {
    const { uuid, contentLoading, species, shelter, loadSpecies, loadShelter } = this.props

    if (!shelter) {
      loadShelter({
        search: {
          uuid: uuid,
          contract_options: {
            with: {
              deleted: false
            }
          },
          organization_question_shelters: {
            with: {
              deleted: false,
              kiosk_reason_id: null,
              question_shelter_species: {
                with: true
              }
            }
          },
          organization_branches: {
            with: {
              deleted: false
            }
          },
          shelter_contract: {
            with: true
          }
        },
        options: {
          _force_ids: true
        }
      })
    }

    if (!contentLoading && (!species || species.length === 0)) {
      loadSpecies({
        options: {
          _force_ids: true,
          limit:9999
        }
      })
    }
  }

  renderAdd = () => {
    const { uuid, permissions }: any = this.props
    if (!permissions.create) return null

    return (
      <Link to={`/organization/shelter/${uuid}/product/add`}>
        <Button type="primary" shape="round">
        Add new product
        </Button>
      </Link>
    )
  }

  render() {
    const { uuid, contentLoading, species, shelter, permissions, history, match, loadSpecies } = this.props
    const { params: { entityUuid } }: any = match

    const branchToFilter = shelter?.organization_branches?.map(branch => {
      return {
        value: branch.id,
        text: branch.name
      }
    }) || []

    const specieToFilter = species?.map(specie => {
      return {
        value: specie.id,
        text: specie.name
      }
    }) || []

    if (entityUuid) {
      return (
        <ShelterProductConsumer>
          {({ fetching, product, error, requestShelterProductFind, requestShelterProductCreate, requestShelterProductUpdate }) => (
            <ShelterProductForm
              uuid={entityUuid !== 'add' ? entityUuid : null}
              data={product}
              error={error}

              shelterUuid={uuid}
              shelter={shelter}

              species={species}

              loading={fetching || false}
              contentLoading={contentLoading}
              history={history}

              loadProduct={requestShelterProductFind}
              loadSpecies={loadSpecies}

              dispatchCreate={requestShelterProductCreate}
              dispatchUpdate={requestShelterProductUpdate}
            />
          )}
        </ShelterProductConsumer>
      )
    }

    return (
      <ShelterProductConsumer>
        {({ fetching, products, pagination, requestShelterProductList, requestShelterProductDelete }) => (
          <>
            <Card title="Filters" style={{marginBottom: 25}}>
              <Filters size="small" defaultSubmitOptions={this.productDispatchOptions} submitDispatch={requestShelterProductList} loading={fetching}>
                {({ values, handleFilterChange }: any) => (
                  <Row gutter={9}>
                    <Col xs={24} md={5}>
                      <FilterItem
                        name="uuid"
                        type={Types.INPUT}
                        placeholder="UUID"
                        value={values['uuid']}
                        size="small"
                        options={{
                          input: {
                            allowClear: true
                          }
                        }}
                        onChange={handleFilterChange}
                      />
                    </Col>
                    <Col xs={24} md={5}>
                      <FilterItem
                        name="name"
                        type={Types.INPUT}
                        placeholder="Name"
                        value={values['name']}
                        size="small"
                        options={{
                          input: {
                            allowClear: true
                          }
                        }}
                        onChange={handleFilterChange}
                      />
                    </Col>
                    <Col xs={24} md={6}>
                      <FilterItem
                        name="description"
                        type={Types.INPUT}
                        placeholder="Description"
                        value={values['description']}
                        size="small"
                        options={{
                          input: {
                            allowClear: true
                          }
                        }}
                        onChange={handleFilterChange}
                      />
                    </Col>
                    <Col xs={24} md={4}>
                      <FilterItem
                        name="product_branch.branch_id"
                        loading={!shelter}
                        type={Types.SELECT}
                        placeholder="Location"
                        data={branchToFilter as any || []}
                        value={values['product_branch.branch_id']}
                        size="small"
                        options={{
                          select: {
                            allowClear: true,
                            showSearch: true
                          }
                        }}
                        onChange={handleFilterChange}
                      />
                    </Col>
                    <Col xs={24} md={4}>
                      <FilterItem
                        name="product_specie.specie_id"
                        loading={contentLoading}
                        type={Types.SELECT}
                        placeholder="Species"
                        data={specieToFilter as any || []}
                        value={values['product_specie.specie_id']}
                        size="small"
                        options={{
                          select: {
                            allowClear: true,
                            showSearch: true
                          }
                        }}
                        onChange={handleFilterChange}
                      />
                    </Col>
                  </Row>
                )}
              </Filters>
            </Card>

            <Card title="List of Products" extra={this.renderAdd()}>
              <ShelterProductList shelterUuid={uuid} loading={fetching} products={products} pagination={pagination} permissions={permissions} history={history} deleteProduct={requestShelterProductDelete} loadProducts={requestShelterProductList} />
            </Card>
          </>
        )}
      </ShelterProductConsumer>
    )
  }
}

export default withRouter(Product)
